import Oidc from "oidc-client";
import { MessageBox, Loading } from "element-ui";
import commonJs from "../public/common";
import { handleError } from "../public/error-info";

const apiHost = process.env.API_ROOT; //接口前缀地址
const saasHost = process.env.SAAS_HOST; //saas网站首页
const saasAuth = process.env.SAAS_AUTH; //saas登录
const manualService = process.env.MANUAL_SERVICE; //文档中心接口前缀地址
// const apiHost = "https://api.vesaas.cn/identityService"; //接口前缀地址
// const saasHost = "https://vesaas.cn/"; //saas网站首页
// const saasAuth = "https://auth.vesaas.cn/"; //saas登录
var config = {
  authority: saasAuth,
  client_id: "admin-saas-js-client",
  clockSkew: 1800, //默认是5分钟，修改为30分钟
  redirect_uri: saasHost + "callback",
  response_type: "id_token token",
  scope:
    "openid profile vatadmin saasAdminFilesServer adminIdentity adminTradeMarkRegistration contentsService cloudStorageService developerService platformShop businessCharge tenantService businessCharge userOperationLog datastatisticsService trackingYeeService notificationService merchandiseAdminService affiliateAdminService",
  post_logout_redirect_uri: saasHost
};
var mgr = new Oidc.UserManager(config);

const utils = {
  isLogin(permissCode, next) {
    mgr.getUser().then(function(user) {
      var profile = localStorage["profile"]
        ? JSON.parse(localStorage["profile"])
        : "";
      if (user) {
        if (!profile) {
          utils.getApi("/Accounts/permissions", "GET", "", data => {
            // let res = JSON.parse(data)
            localStorage["profile"] = data;
            profile = JSON.parse(data);
            if (permissCode && profile.permissions.indexOf(permissCode) == -1) {
              next("/vsUs/UserCenterMenuItem");
              MessageBox.alert("您当前没有访问当前页面的权限，请联系管理员", {
                confirmButtonText: "确定",
                callback: action => {
                  next("/vsUs/UserCenterMenuItem");
                  // location.href = saasHost;
                }
              });
              return false;
            }
          });
        } else {
          if (permissCode && profile.permissions.indexOf(permissCode) == -1) {
            next("/vsUs/UserCenterMenuItem");
            MessageBox.alert("您当前没有访问当前页面的权限，请联系管理员", {
              confirmButtonText: "确定",
              callback: action => {
                next("/vsUs/UserCenterMenuItem");
                // location.href = saasHost;
              }
            });
            return false;
          }
        }

        localStorage["accessToken"] = user.access_token;
        // localStorage["profile"] = profile
        next();
      } else {
        utils.login();
      }
    });
  },
  justIsLogin(orLogin) {
    mgr.getUser().then(function(user) {
      if (user) {
        orLogin(true);
      } else {
        orLogin(false);
      }
    });
  },
  // 请求带token的接口
  getApi(hostUrl, method, parm, callback, falseCall) {
    // loading开始
    commonJs.beginLoading();
    if (hostUrl.indexOf("http") == -1) {
      hostUrl = apiHost + hostUrl;
    }
    // mgr.getUser().then(function (user) {
    // if(user) {
    var url = hostUrl;
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onload = function() {
      // loading 关闭
      commonJs.finishLoading();
      if (xhr.status == 200) {
        callback(xhr.responseText);
      } else if (xhr.status == 500) {
        localStorage.removeItem("menuitems");
        MessageBox.alert(
          "对不起，系统发生故障！我们正在紧急处理，请稍后再试！",
          {
            confirmButtonText: "确定",
            callback: action => {
              // loading 关闭
              commonJs.finishLoading();
            }
          }
        );
      } else if (xhr.status == 401) {
        localStorage["lastHref"] = window.location.href;
        utils.login();
      } else {
        handleError(JSON.parse(xhr.responseText));
        falseCall && falseCall(xhr.responseText);
      }
    };
    xhr.setRequestHeader(
      "Authorization",
      localStorage["accessToken"] ? "Bearer " + localStorage["accessToken"] : ""
    );
    // xhr.setRequestHeader("Authorization","Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IkJFQ0M4NUNBOTc1MDEyQTZERUMzNzk2MzczODBBN0ZGQUZGMjkzMEMiLCJ0eXAiOiJKV1QiLCJ4NXQiOiJ2c3lGeXBkUUVxYmV3M2xqYzRDbl82X3lrd3cifQ.eyJuYmYiOjE1MzgyMjEwOTQsImV4cCI6MTUzODI2NDI5NCwiaXNzIjoiaHR0cHM6Ly9hdXRoLmdsb2JhbHBjZi5jb20uY24iLCJhdWQiOlsiaHR0cHM6Ly9hdXRoLmdsb2JhbHBjZi5jb20uY24vcmVzb3VyY2VzIiwidmF0YWRtaW4iLCJzYWFzQWRtaW5GaWxlc1NlcnZlciIsImFkbWluSWRlbnRpdHkiXSwiY2xpZW50X2lkIjoiYWRtaW4tc2Fhcy1qcy1jbGllbnQiLCJzdWIiOiI4OTVjMjdmZC0wOWIyLTQxNTMtYThkYi0zNGJiNWY2ZTY2NTIiLCJhdXRoX3RpbWUiOjE1MzgxODY1MDMsImlkcCI6ImxvY2FsIiwicHJlZmVycmVkX3VzZXJuYW1lIjoibGVvLmh1YW5nbGlhbmcyMDE1QGdtYWlsLmNvbSIsInVuaXF1ZV9uYW1lIjoibGVvLmh1YW5nbGlhbmcyMDE1QGdtYWlsLmNvbSIsImZ1bGxfbmFtZSI6IuS6ruWTpSIsInJvbGUiOiJQbGF0Zm9ybUFkbWluIiwiZW1haWwiOiJsZW8uaHVhbmdsaWFuZzIwMTVAZ21haWwuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsInNjb3BlIjpbIm9wZW5pZCIsInByb2ZpbGUiLCJ2YXRhZG1pbiIsInNhYXNBZG1pbkZpbGVzU2VydmVyIiwiYWRtaW5JZGVudGl0eSJdLCJhbXIiOlsicHdkIl19.sjx95YaK0dClyHFovlWaz3GHxP4m2h1daYTVvyi6FiSO1toYM20epOsve8b1SqbZdh9SUF4rX4V1DqvSfiDO4LJvQgU0acrZ50o-eGHr1Nd--SyCD7AS55ntzSdlGQYGRjfqgSrG2QzlxoX1qj1k8Crer0TZNZdzF-fYPSaK2YgmROxQLeGe6F4hfguFKs5pKRnZilLCZnpUNVNbijeLgHXRxMMB-Hi-FFjXbHZpJjwMUfJ0aKsI_F2rv1ju3QK2bFNspfVbcfWbO8XtrM_-7tKnyWNvPJz4DjnyvGUIN1Wd29tLgsrWRQVajNoEKAwofkwDd-0vMmtEj61d3GkGoQ");
    xhr.send(parm);
    //   }else{
    //     utils.login();
    //   }
    // });
  },
  // 访问公共接口
  getApiPublic(hostUrl, method, parm, callback, falseCall) {
    // loading开始
    commonJs.beginLoading();
    var url = apiHost + hostUrl;
    var xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Content-type", "application/json");
    xhr.onload = function() {
      if (xhr.status == 200) {
        // loading 关闭
        commonJs.finishLoading();
        callback(xhr.responseText);
      } else if (xhr.status == 500) {
        localStorage.removeItem("menuitems");
        MessageBox.alert(
          "对不起，系统发生故障！我们正在紧急处理，请稍后再试！",
          {
            confirmButtonText: "确定",
            callback: action => {
              // loading 关闭

              commonJs.finishLoading();
            }
          }
        );
      } else {
        // loading 关闭
        commonJs.finishLoading();
        handleError(JSON.parse(xhr.responseText));
        falseCall(xhr.status, xhr.responseText);
      }
    };
    xhr.send(parm);
  },
  // 登录
  login() {
    mgr.signinRedirect();
    mgr.getUser().then(function(user) {
      if (user) {
        localStorage["OidcUser1"] = JSON.stringify(user);
        localStorage["accessToken"] = user.access_token;
        localStorage["profile"] = JSON.stringify(user.profile);
      }
    });
  },
  login404() {
    location.href = saasHost + "notFound";
  },
  // 登出
  loginOut() {
    mgr.signoutRedirect();
    localStorage.removeItem("accessToken");
    localStorage.removeItem("menuitems");
    localStorage.removeItem("lastHref");
    localStorage.removeItem("profile");
    localStorage.removeItem("user");
    localStorage.removeItem("newProductData");
    localStorage.removeItem("toSaaSWhere");
    sessionStorage.clear();
  }
};
export default utils;
window.login401 = utils.login;
window.login404 = utils.login404;



// WEBPACK FOOTER //
// ./src/public/oidcRoot.js